import { AlpineComponent } from '@alpinejs/csp';
import { pushTrackingEvent } from '../../javascripts/events/tracking';

const SearchDialog = (): AlpineComponent => ({
  searchValue: '',
  initialOpen: false,
  isLoading: false,
  isVisible: false,
  timeout: null,

  init() {
    this.searchValue = this.$root.getAttribute('data-search-value');
    this.initialOpen = this.$root.getAttribute('data-initial-open') === 'true';

    this.$watch('searchValue', () => this.handleSearch());

    this.$refs.dialog.addEventListener('close', () => {
      (this.$store as any).general.isSearchOpen = false;
    });
  },
  openDialog() {
    if (this.timeout) clearTimeout(this.timeout);
    (this.$refs.dialog as HTMLDialogElement).showModal();
  },

  closeDialog() {
    this.timeout = setTimeout(() => {
      (this.$refs.dialog as HTMLDialogElement).close();
    }, 300);
  },

  handleChange(event: Event) {
    this.searchValue = (event.target as HTMLInputElement).value;

    if (this.searchValue.length >= 3) {
      pushTrackingEvent('trackSiteSearch', this.searchValue);
    }
  },

  handleSearch() {
    this.isLoading = true;

    if (this.searchValue) {
      const url = new URL(window.location.href);
      url.searchParams.set('q', this.searchValue);
      this.$refs.content.scrollTo({ top: 0, behavior: 'smooth' });
    }

    this.isLoading = false;
  },

  handleOutsideClick(event: MouseEvent) {
    if (this.searchValue) return;

    const rect = this.$refs.dialog.getBoundingClientRect();

    if (
      rect.left > event.clientX ||
      rect.right < event.clientX ||
      rect.top > event.clientY ||
      rect.bottom < event.clientY
    ) {
      (this.$store as any).general.closeSearch();
    }
  },

  handleOpen() {
    this.$store.general.openSearch();
    this.openDialog();
  },
  handleClose() {
    this.$store.general.closeSearch();
    this.closeDialog();
  },
  handleFilterClick() {
    this.isVisible = !this.isVisible;
  },

  getClassName() {
    return {
      'search-dialog--is-open': this.$store.general.isSearchOpen,
      'search-dialog--has-value': this.searchValue !== '',
      'search-dialog--filter-is-visible': this.isVisible
    };
  }
});

export default SearchDialog;
